import { ReactComponent as ArrowIcon } from 'assets/arrow.svg';
import Link from 'gatsby-link';
import TweenLite from "gsap/umd/TweenLite.js";
import React, { PureComponent } from 'react';
import styled from '@emotion/styled'
import { fontSize, Grid, MixBlendDifference, MixBlendText, zIndexes } from 'style';
import { MethodsService } from 'utils';

class GetInTouch extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {};
        this.setRandomPosition = this.setRandomPosition.bind(this);
    }
    componentDidMount() {
        this.setRandomPosition();
    }

    setRandomPosition() {
        var BA = [],
            points = 100,
            duration = 4,
            offset = circleHeight;
        for (var i = 0; i < points; i++) {
            let pos = {};
            if (i % 4 == 0) {
                pos = {
                    x: (window.innerWidth - circleHeight) / 2,
                    y: (window.innerHeight - circleHeight) / 2,
                };
            } else {
                if (Math.random() > 0.5) {
                    pos = {
                        x: Math.round(Math.random()) * window.innerWidth,
                        y:
                            Math.random() * (window.innerHeight + offset) -
                            offset,
                    };
                } else {
                    pos = {
                        x:
                            Math.random() * (window.innerWidth + offset) -
                            offset,
                        y: Math.round(Math.random()) * window.innerHeight,
                    };
                }
            }
            BA.push(pos);
        }
        TweenLite.to(document.querySelector('.circle'), points * duration, {
            bezier: {
                timeResolution: 0,
                type: 'thru',
                curviness: 0.7,
                values: BA,
            },
            // ease: Linear.easeNone,
            onComplete: this.setRandomPosition,
        });
    }

    render() {
        const { text } = this.props;
        return (
            <GetInTouchWrapper id="GoBack">
                <Grid.Row>
                    <GetInTouchBar>
                        <Circle
              /*removed innerRef*/ ref={el => (this.circle = el)}
                            className="circle"
                        />
                        <Link
                            to="/contact/"
                            data-cursor="focus"
                            data-cursor-persistance="200">
                            <Text>
                                {text}
                                <ArrowIcon className="icon" />
                            </Text>
                        </Link>
                    </GetInTouchBar>
                </Grid.Row>
            </GetInTouchWrapper>
        );
    }
}

const circleHeight = 186;

const GetInTouchWrapper = styled.div`
    width: 100%;
    height: 100vh;
    position: relative;
    top: 0;

    & > div {
        width: 100%;
        height: 100vh;
        position: absolute;
        bottom: 0;
        clip: rect(0, auto, auto, 0);
        background-color: #000;
        z-index: ${zIndexes.zLetsFight};
    }

    a {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        text-decoration: none;
    }
`;
const GetInTouchBar = styled.div`
    text-align: center;
    width: 100%;
    isolation: isolate;
    width: 100%;
    height: 100vh;
    align-items: center;
    position: fixed;
    bottom: 0;
`;

const Circle = styled.div`
    height: ${circleHeight}px;
    width: ${circleHeight}px;
    background-color: #ffffff;
    border-radius: 100%;
    position: absolute;
    ${MixBlendDifference};

    /* ${MixBlendText({
    fallbackcolor: '#fff',
    fallbackshadowcolor: 'transparent',
})}; */
`;

const Text = styled.div`
    max-width: 90%;
    font-size: ${fontSize(40)};
    color: #fff;
    .icon {
        vertical-align: middle;
        height: 28px;
        width: 22px;
        transform: rotate(-90deg);
        margin-left: 20px;
        margin-top: -9px;
        transition: all 0.5s;
        path {
            stroke: #fff;
        }
    }
    &:hover {
        .icon {
            transform: rotate(-90deg) translateY(10px);
        }
    }
`;

export default GetInTouch;
